export default "__VITE_ASSET__BomdqdkF__"